import { useEffect, useRef } from "react";
import { supportsShadowDOM } from "lib/shadowDOM";

const KEY_CODE_TAB = 9;

const useOuterClick = callback => {
  const innerRef = useRef();
  const callbackRef = useRef();

  // set current callback in ref, before second useEffect uses it
  useEffect(() => {
    // useEffect wrapper to be safe for concurrent mode
    callbackRef.current = callback;
  });

  useEffect(() => {

    const currentRoot = !supportsShadowDOM() ? document : innerRef.current && innerRef.current.getRootNode();

    const handleMouse = (e, onDocument = false) => {

      if (onDocument) {
        if (!e.target.shadowRoot) {
          callbackRef.current(e);
        }
      } else {
        if (innerRef.current &&
          callbackRef.current &&
          !innerRef.current.contains(e.target)
        ) {
          callbackRef.current(e);
        }
      }
    };

    const handleKeys = e => {
      if (
        innerRef.current &&
        e.keyCode === KEY_CODE_TAB &&
        !innerRef.current.contains(currentRoot.activeElement)
      ) {
        callbackRef.current(e);
      }
    };

    // Use the "mousedown" event instead of "click" to prevent firing an event on a mouseup
    // that would trigger the callback immedietaly after the first click (mousedown) happened.
    if (currentRoot) {
      // document.addEventListener("mousedown", handleMouse);
      // document.addEventListener("keyup", handleKeys);
      currentRoot.addEventListener("mousedown", (e) => handleMouse(e));
      currentRoot.addEventListener("keyup", (e) => handleKeys(e));

      if (supportsShadowDOM()) {
        document.addEventListener("mousedown", (e) => handleMouse(e, true));
        document.addEventListener("keyup", (e) => handleKeys(e, true));
      }
      return () => {
        // document.removeEventListener("mousedown", handleMouse);
        // document.removeEventListener("keyup", handleKeys);
        currentRoot.removeEventListener("mousedown", (e) => handleMouse(e));
        currentRoot.removeEventListener("keyup", (e) => handleKeys(e));

        if (supportsShadowDOM()) {
          document.removeEventListener("mousedown", (e) => handleMouse(e, true));
          document.removeEventListener("keyup", (e) => handleKeys(e, true));
        }
      };
    }
  }, []); // no need for callback + innerRef dep

  return innerRef; // return ref; client can omit `useRef`
};

export default useOuterClick;
